// Separate translations bundle for the giveaway (raffle) landing page.
// Registered as a dedicated i18next namespace ("raffle") from Raffle.jsx so it
// stays isolated from the large app-wide translation file.

export const RAFFLE_NS = 'raffle';

const ru = {
  header: {
    brand: 'TeSalut',
    tagline: 'Розыгрыш',
    skipToContent: 'Перейти к содержимому',
  },
  lang: {
    label: 'Язык',
    ru: 'RU',
    ro: 'RO',
    ruFull: 'Русский',
    roFull: 'Română',
  },
  theme: {
    label: 'Тема',
    toLight: 'Светлая тема',
    toDark: 'Тёмная тема',
  },
  hero: {
    titlePrefix: 'Розыгрыш ',
    titleAccent: 'профессионального клининга',
    titleSuffix: ' от TeSalut',
    subtitle:
      'Дарим премиальные услуги клининга нашим клиентам и партнёрам. Один прозрачный розыгрыш — реальные победители.',
    cta: 'Начать розыгрыш',
    secondaryCta: 'Смотреть призы',
    statParticipants: 'Участников',
    statPrizes: 'Приза',
    statLive: 'В эфире',
  },
  prizes: {
    title: 'Что можно выиграть',
    subtitle: 'Четыре услуги профессионального клининга. Выберите приз для розыгрыша.',
    select: 'Разыграть приз',
    selected: 'Выбрано',
    featuredBadge: 'Главный приз',
    apartmentTitle: 'Уборка и обслуживание квартиры',
    apartmentDesc:
      'Комплексная уборка квартиры: наведение порядка, чистка поверхностей и уют в каждой комнате.',
    checkupTitle: 'Технический чек-ап',
    checkupDesc:
      'Полная техническая диагностика и профилактический осмотр бытовой техники и коммуникаций в доме.',
    sofaTitle: 'Химчистка дивана',
    sofaDesc:
      'Глубокая чистка обивки дивана: удаление пятен, запахов и аллергенов с бережной сушкой.',
    carpetTitle: 'Чистка ковров',
    carpetDesc:
      'Глубокая экстракторная чистка ковров и покрытий: удаление пятен, запахов и аллергенов с бережной сушкой.',
  },
  participants: {
    title: 'Наши участники',
    subtitle: 'Все клиенты, которые оформили заказ за выбранный период.',
    loading: 'Загружаем участников…',
    empty: 'Нет участников за выбранный период',
    pickRange: 'Выберите период, чтобы увидеть участников',
    countLabel: 'участников',
  },
  dateRange: {
    label: 'Период розыгрыша',
    placeholder: 'Выберите период',
    placeholderPartial: 'Выберите дату окончания',
    clear: 'Очистить',
    invalid: 'Дата окончания раньше даты начала',
  },
  machine: {
    title: 'Машина розыгрыша',
    subtitle: 'Выберите приз и запустите розыгрыш. Победитель определяется случайно.',
    choosePrize: 'Выберите приз для розыгрыша',
    start: 'Начать розыгрыш',
    spinning: 'Определяем победителя…',
    again: 'Запустить ещё раз',
    statusReady: 'Готово к розыгрышу',
    statusArming: 'Приготовьтесь…',
    statusSpinning: 'Барабан крутится',
    statusSlowing: 'Замедляемся… кто же это?',
    statusDone: 'Победитель определён',
    needParticipants: 'Недостаточно участников для розыгрыша',
    announceWinner: 'Победитель: {{name}}',
  },
  winner: {
    badge: 'Победитель',
    congrats: 'Поздравляем',
    wins: 'забирает приз',
    prize: 'Приз',
    copyLink: 'Скопировать профиль',
    copied: 'Скопировано',
    again: 'Запустить ещё раз',
    close: 'Закрыть',
  },
  transparency: {
    statement: 'Победитель выбирается случайно среди всех участников.',
    detail:
      'Розыгрыш проходит честно: каждый участник имеет равные шансы. Результат не зависит от порядка в списке.',
  },
  footer: {
    support: 'Поддержка клиентов',
    follow: 'Мы в соцсетях',
    privacy: 'Политика конфиденциальности',
    rights: '© {{year}} COOLCHAS COMMUNITY SRL — TeSalut. Все права защищены.',
  },
};

const ro = {
  header: {
    brand: 'TeSalut',
    tagline: 'Extragere',
    skipToContent: 'Sari la conținut',
  },
  lang: {
    label: 'Limbă',
    ru: 'RU',
    ro: 'RO',
    ruFull: 'Русский',
    roFull: 'Română',
  },
  theme: {
    label: 'Temă',
    toLight: 'Temă deschisă',
    toDark: 'Temă întunecată',
  },
  hero: {
    titlePrefix: 'Extragere de ',
    titleAccent: 'servicii profesionale de curățenie',
    titleSuffix: ' de la TeSalut',
    subtitle:
      'Oferim servicii premium de curățenie clienților și partenerilor noștri. O extragere transparentă — câștigători reali.',
    cta: 'Începe extragerea',
    secondaryCta: 'Vezi premiile',
    statParticipants: 'Participanți',
    statPrizes: 'Premii',
    statLive: 'În direct',
  },
  prizes: {
    title: 'Ce poți câștiga',
    subtitle: 'Patru servicii de curățenie profesională. Alege premiul pentru extragere.',
    select: 'Extrage premiul',
    selected: 'Selectat',
    featuredBadge: 'Premiul principal',
    apartmentTitle: 'Curățenie și întreținere apartament',
    apartmentDesc:
      'Curățenie completă a apartamentului: ordine, curățarea suprafețelor și confort în fiecare cameră.',
    checkupTitle: 'Check-up tehnic',
    checkupDesc:
      'Diagnosticare tehnică completă și verificare preventivă a electrocasnicelor și instalațiilor din casă.',
    sofaTitle: 'Curățare canapea',
    sofaDesc:
      'Curățare profundă a tapițeriei canapelei: elimină petele, mirosurile și alergenii, cu uscare delicată.',
    carpetTitle: 'Curățare covoare',
    carpetDesc:
      'Curățare profundă prin extracție a covoarelor: elimină petele, mirosurile și alergenii, cu uscare delicată.',
  },
  participants: {
    title: 'Participanții noștri',
    subtitle: 'Toți clienții care au plasat o comandă în perioada selectată.',
    loading: 'Se încarcă participanții…',
    empty: 'Niciun participant în perioada selectată',
    pickRange: 'Alege o perioadă pentru a vedea participanții',
    countLabel: 'participanți',
  },
  dateRange: {
    label: 'Perioada extragerii',
    placeholder: 'Alege perioada',
    placeholderPartial: 'Alege data de final',
    clear: 'Golește',
    invalid: 'Data de final este înainte de data de început',
  },
  machine: {
    title: 'Mașina de extragere',
    subtitle: 'Alege premiul și pornește extragerea. Câștigătorul este ales aleatoriu.',
    choosePrize: 'Alege premiul pentru extragere',
    start: 'Începe extragerea',
    spinning: 'Alegem câștigătorul…',
    again: 'Extrage din nou',
    statusReady: 'Gata de extragere',
    statusArming: 'Pregătește-te…',
    statusSpinning: 'Ruleta se învârte',
    statusSlowing: 'Încetinim… cine va fi?',
    statusDone: 'Câștigătorul a fost ales',
    needParticipants: 'Nu sunt suficienți participanți pentru extragere',
    announceWinner: 'Câștigător: {{name}}',
  },
  winner: {
    badge: 'Câștigător',
    congrats: 'Felicitări',
    wins: 'câștigă premiul',
    prize: 'Premiu',
    copyLink: 'Copiază profilul',
    copied: 'Copiat',
    again: 'Extrage din nou',
    close: 'Închide',
  },
  transparency: {
    statement: 'Câștigătorul este ales aleatoriu dintre toți participanții.',
    detail:
      'Extragerea este corectă: fiecare participant are șanse egale. Rezultatul nu depinde de ordinea din listă.',
  },
  footer: {
    support: 'Suport clienți',
    follow: 'Urmărește-ne',
    privacy: 'Politica de confidențialitate',
    rights: '© {{year}} COOLCHAS COMMUNITY SRL – TeSalut. Toate drepturile rezervate.',
  },
};

// English mirror — safety fallback for the shared i18n instance.
const en = {
  header: { brand: 'TeSalut', tagline: 'Giveaway', skipToContent: 'Skip to content' },
  lang: { label: 'Language', ru: 'RU', ro: 'RO', ruFull: 'Русский', roFull: 'Română' },
  theme: { label: 'Theme', toLight: 'Light theme', toDark: 'Dark theme' },
  hero: {
    titlePrefix: 'The TeSalut ',
    titleAccent: 'professional cleaning',
    titleSuffix: ' giveaway',
    subtitle:
      'We are giving away premium cleaning services to our customers and partners. One transparent draw — real winners.',
    cta: 'Start Draw',
    secondaryCta: 'See prizes',
    statParticipants: 'Participants',
    statPrizes: 'Prizes',
    statLive: 'Live',
  },
  prizes: {
    title: 'What you can win',
    subtitle: 'Four professional cleaning services. Pick a prize for the draw.',
    select: 'Draw this prize',
    selected: 'Selected',
    featuredBadge: 'Grand prize',
    apartmentTitle: 'Apartment Cleaning & Maintenance',
    apartmentDesc:
      'Full apartment cleaning: tidying up, surface cleaning and a fresh, cared-for home in every room.',
    checkupTitle: 'Technical Check-up',
    checkupDesc:
      'Full technical diagnostics and a preventive inspection of home appliances and utilities.',
    sofaTitle: 'Sofa Cleaning',
    sofaDesc:
      'Deep upholstery cleaning for your sofa: removes stains, odours and allergens with gentle drying.',
    carpetTitle: 'Professional Carpet Cleaning',
    carpetDesc:
      'Deep extraction cleaning for carpets and rugs: removes stains, odours and allergens with gentle drying.',
  },
  participants: {
    title: 'Our participants',
    subtitle: 'Every customer who placed an order in the selected period.',
    loading: 'Loading participants…',
    empty: 'No participants in the selected period',
    pickRange: 'Pick a date range to see participants',
    countLabel: 'participants',
  },
  dateRange: {
    label: 'Draw period',
    placeholder: 'Pick a date range',
    placeholderPartial: 'Pick an end date',
    clear: 'Clear',
    invalid: 'End date is before the start date',
  },
  machine: {
    title: 'Raffle machine',
    subtitle: 'Choose a prize and start the draw. The winner is selected at random.',
    choosePrize: 'Choose a prize to draw',
    start: 'Start Draw',
    spinning: 'Selecting the winner…',
    again: 'Draw again',
    statusReady: 'Ready to draw',
    statusArming: 'Get ready…',
    statusSpinning: 'Reel is spinning',
    statusSlowing: 'Slowing down… who is it?',
    statusDone: 'Winner selected',
    needParticipants: 'Not enough participants for the draw',
    announceWinner: 'Winner: {{name}}',
  },
  winner: {
    badge: 'Winner',
    congrats: 'Congratulations',
    wins: 'wins the prize',
    prize: 'Prize',
    copyLink: 'Copy profile link',
    copied: 'Copied',
    again: 'Draw again',
    close: 'Close',
  },
  transparency: {
    statement: 'The winner is selected randomly from all participants.',
    detail:
      'The draw is fair: every participant has an equal chance. The result does not depend on list order.',
  },
  footer: {
    support: 'Customer support',
    follow: 'Follow us',
    privacy: 'Privacy Policy',
    rights: '© {{year}} COOLCHAS COMMUNITY SRL – TeSalut. All rights reserved.',
  },
};

export const raffleTranslations = { ru, ro, en };

export default raffleTranslations;
